export default function MyPage() {
  return (
    <>
      <div>아직안만드럿서</div>
    </>
  );
}
